// Third-parties.
import { useEffect, useContext } from 'react';
import ReactTooltip from 'react-tooltip';

// Contexts.
import { TimeRangeContext } from '../../context/TimeRangeContext';

function InstanaDatabaseButton(props: { instanaServiceUrl: string }) {
    const { timeRange } = useContext(TimeRangeContext);
        
	useEffect (() =>
	{
		ReactTooltip.rebuild ();
	}, []);

    return (
        <button type="button" className="btn btn-xsm btn-outline-secondary float-end" data-tip="View this database in Instana" onClick={() => window.open(`${props.instanaServiceUrl}?timeline.to=${timeRange.to.valueOf()}&timeline.fm=${timeRange.from.valueOf()}&timeline.ws=${timeRange.to.diff(timeRange.from, 'millisecond')}`, "_blank")}><i className="fak fa-stan fa-fw" aria-hidden="true"></i>Instana</button>
    );
}

export default InstanaDatabaseButton;
